import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
type Cart = {
  [key: string]: string | undefined | number;
};

type CartStore = {
  cart: Cart;
  updateCart: (cart: Cart) => void;
  resetCart: () => void;
};

const useCartStore = create(
  persist<CartStore>(
    (set) => ({
      cart: {},
      updateCart: (cart: Cart) => set({ cart }),

      resetCart: () => set({ cart: {} }),
    }),
    {
      name: "cart-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

const useLocalCart = () => {
  const { cart, updateCart, resetCart } = useCartStore();

  return { cart, updateCart, resetCart };
};

export default useLocalCart;
